var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13C21.25 8.06563 25.9711 5.5461 36.25 5.50001C36.4143 5.49939 36.5772 5.5313 36.7291 5.5939C36.881 5.6565 37.0191 5.74855 37.1353 5.86474C37.2515 5.98094 37.3435 6.11899 37.4061 6.27092C37.4687 6.42286 37.5006 6.58568 37.5 6.75001V29.25C37.5 29.5815 37.3683 29.8995 37.1339 30.1339C36.8995 30.3683 36.5815 30.5 36.25 30.5C26.25 30.5 22.3867 32.5164 20 35.5M20 13C18.75 8.06563 14.0289 5.5461 3.75001 5.50001C3.58568 5.49939 3.42286 5.5313 3.27092 5.5939C3.11899 5.6565 2.98094 5.74855 2.86474 5.86474C2.74855 5.98094 2.6565 6.11899 2.5939 6.27092C2.5313 6.42286 2.49939 6.58568 2.50001 6.75001V29.0992C2.50001 29.8711 2.97813 30.5 3.75001 30.5C13.75 30.5 17.6274 32.5313 20 35.5M20 13V35.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookDark);
export default __webpack_public_path__ + "static/media/BookDark.fdf60ac47d8f55bbe870e415c5909d22.svg";
export { ForwardRef as ReactComponent };